export default "__VITE_ASSET__C$2Fe4rZ__"